import React, { Fragment, useState } from "react";
import SimpleReactValidator from "simple-react-validator";
import { toast } from "react-toastify";
import { Link, useNavigate } from "react-router-dom";
import Header from "../../components/header/Header";
import sicon1 from "../../icons/icon_google.svg";
import shape1 from "../../images/shapes/shape_divider.svg";
import Footer from "../../components/footer/Footer";

const SigninPage = (props) => {
  const push = useNavigate();

  const [value, setValue] = useState({
    email: "user@gmail.com",
    password: "123456",
    remember: false,
  });

  const changeHandler = (e) => {
    setValue({ ...value, [e.target.name]: e.target.value });
    validator.showMessages();
  };

  const [validator] = React.useState(
    new SimpleReactValidator({
      className: "errorMessage",
    })
  );

  const submitForm = (e) => {
    e.preventDefault();
    if (validator.allValid()) {
      setValue({
        email: "",
        password: "",
        remember: false,
      });
      validator.hideMessages();

      const userRegex = /^user+.*/gm;
      const email = value.email;

      if (email.match(userRegex)) {
        toast.success("Successfully Login on Coinlye !");
        push("/home_ico");
      }
    } else {
      validator.showMessages();
      toast.error("Empty field is not allowed!");
    }
  };

  return (
    <Fragment>
      <div className="index_ico page_wrapper">
        <Header />
        <main className="page_content">
          <section className="register_section section_decoration">
            <div className="container">
              <div className="row justify-content-center align-items-center">
                <div className="col-lg-7">
                  <div>
                    <h1
                      className="hero_title mb-3"
                      data-aos="fade-up"
                      data-aos-duration="800"
                    >
                      {" "}
                      Welcome to TopCoin UK - Where Loyalty Turns into Real
                      Rewards!
                    </h1>
                    <p>
                      Once someone joins TopCoin UK, they’re given their own
                      Personal ID and Referring customer’s numbers — instantly unlocking access to
                      our powerful earning system.
                    </p>
                    <h3 className="" data-aos="fade-up" data-aos-duration="800">
                      How Agents Earn Free TopCoin UK Units:
                    </h3>
                    As a TopCoin UK Agent, you earn free units effortlessly
                    every time you refer someone!
                    <ul>
                      <li>When someone you introduce makes a purchase,</li>
                      <li> And they enter your Referring customer’s numbers,</li>
                      <li>
                        You’ll instantly receive the same number of units they
                        earn — automatically!
                      </li>
                    </ul>
                    <p>
                      The more people you refer, the more your unit balance
                      grows — and with it, your TopCoin UK wallet power. Start
                      sharing. Start earning.
                    </p>
                    <p>
                      Be the reason others discover TopCoin UK — and get
                      rewarded every step of the way.
                    </p>
                    <p>Your loyalty is your power. Make it count.</p>
                  </div>
                </div>
                <div className="col-lg-5 position-relative">
                  <form className="register_form" onSubmit={submitForm}>
                    <h1 className="heading_text text-dark text-center">
                      Login to Your Account
                    </h1>
                    <p className="text-center text-dark  opacity-50">
                      Enter your details to login.
                    </p>
                    <Link className="btn_login_google" to="/sign_in">
                      <span className="icon">
                        <img src={sicon1} alt="Google Icon" />
                      </span>
                      <span className="label">Continue with Google</span>
                    </Link>
                    <div className="divider">
                      <img src={shape1} alt="Divider" />
                    </div>
                    <div className="form-group">
                      <label className="input_title" htmlFor="input_email">
                        Email<sup>*</sup>
                      </label>
                      <input
                        className="form-control"
                        placeholder="alma.lawson@example.com"
                        value={value.email}
                        variant="outlined"
                        name="email"
                        label="E-mail"
                        onBlur={(e) => changeHandler(e)}
                        onChange={(e) => changeHandler(e)}
                      />
                      {validator.message(
                        "email",
                        value.email,
                        "required|email"
                      )}
                    </div>
                    <div className="form-group">
                      <label className="input_title" htmlFor="input_pass">
                        Password<sup>*</sup>
                      </label>
                      <input
                        className="form-control"
                        placeholder="***********"
                        value={value.password}
                        variant="outlined"
                        name="password"
                        type="password"
                        label="Password"
                        onBlur={(e) => changeHandler(e)}
                        onChange={(e) => changeHandler(e)}
                      />
                      {validator.message(
                        "password",
                        value.password,
                        "required"
                      )}
                    </div>
                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            id="checkbox_remember_me"
                          />
                          <label
                            className="form-check-label text-dark  opacity-50"
                            htmlFor="checkbox_remember_me"
                          >
                            Remember Me
                          </label>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <p className="forget_pass text-md-end text-dark  opacity-50 mb-0">
                          Forgot password?{" "}
                          <Link to="/sign_in">
                            <u>Reset</u>
                          </Link>
                        </p>
                      </div>
                    </div>
                    <button className="btn" type="submit">
                      <span className="btn_label">Login</span>
                      <span className="btn_icon">
                        <i className="ti-arrow-top-right"></i>
                      </span>
                    </button>
                    <div className="w-full justify-content-center align-items-center text-center">
                      <Link
                        to="/sign_up"
                        className="btn btn-link bg-transparent justify-content-center  border-0 text-decoration-none text-center w-100 text-dark"
                      >
                        <span className="nav_link_label" data-text="Home">
                          Sign Up
                        </span>
                      </Link>
                    </div>
                  </form>
                  {/* <div className="decoration_item shape_flower">
                                        <img src={shape2} alt="Flower" />
                                    </div> */}
                </div>
              </div>
            </div>
          </section>
        </main>
        <Footer/>
      </div>
    </Fragment>
  );
};
export default SigninPage;
